import React, { useState, useEffect } from "react";
import { Button, Modal } from "react-bootstrap";
import { TiArrowSortedDown, TiArrowSortedUp } from "react-icons/ti";
import { apiUpdateProcesses } from "../../../api/ApiProcess";
import { useTranslation } from "react-i18next";

const ModalOrdonner = (props) => {
  const { t } = useTranslation();
  const { show, handleClose, handleRecupDatas, macrosProcess } = props;
  const [orderedMacroProcess, setOrderedMacrosProcess] = useState([]);

  const submitData = async () => {
    const newMacrosProcessForUpdate = [];
    orderedMacroProcess.reverse().forEach((macroProcess, index) => {
      newMacrosProcessForUpdate.push({
        nom: macroProcess.nom,
        _id: macroProcess._id,
        ordre: index,
      });
    });
    await apiUpdateProcesses(newMacrosProcessForUpdate);
    handleRecupDatas();
    handleClose();
  };

  useEffect(() => {
    if (show) {
      setOrderedMacrosProcess(macrosProcess);
    }
  }, [show]); // eslint-disable-line react-hooks/exhaustive-deps

  const changeOrdre = (index, sens) => {
    const orderedMacrosProcessCopy = [...orderedMacroProcess];
    const elementSauvegarde = orderedMacroProcess[index];
    if (sens === "haut") {
      if (index !== 0) {
        orderedMacrosProcessCopy[index] = orderedMacrosProcessCopy[index - 1];
        orderedMacrosProcessCopy[index - 1] = elementSauvegarde;
      }
    }
    if (sens === "bas") {
      if (index !== orderedMacroProcess.length - 1) {
        orderedMacrosProcessCopy[index] = orderedMacrosProcessCopy[index + 1];
        orderedMacrosProcessCopy[index + 1] = elementSauvegarde;
      }
    }
    setOrderedMacrosProcess(orderedMacrosProcessCopy);
  };

  return (
    <Modal show={show} onHide={handleClose}>
      {/* <pre>{JSON.stringify(newMacroProcess, null, 4)}</pre> */}
      <Modal.Header closeButton>
        <Modal.Title>
          {t("admin.PageAdminProcesses.modalOrdonnerTitre")}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {orderedMacroProcess.map((macroProcess, index) => (
          <div className="border m-1 p-2" key={index}>
            <TiArrowSortedUp
              size="1.5em"
              role="button"
              onClick={(e) => changeOrdre(index, "haut")}
            />
            <TiArrowSortedDown
              size="1.5em"
              role="button"
              onClick={(e) => changeOrdre(index, "bas")}
            />
            <span className="ms-1"> {macroProcess.nom}</span>
          </div>
        ))}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="danger" onClick={handleClose}>
          {t("commun.form.button.annuler")}
        </Button>
        <Button variant="success" onClick={submitData}>
          {t("commun.form.button.enregistrer")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalOrdonner;
